<template>
    <loading-box :loading="loading">
        <h2>Upcoming anniversaries <small>(this month)</small></h2>

        <table class="table mt-8" v-if="typeof anniversaries !== 'undefined' && anniversaries.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Client</th>
                    <th class="text-center">Date</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="anniversary in anniversaries">
                    <!-- Name -->
                    <td style="vertical-align: middle;">
                        {{ anniversary.name }}
                    </td>

                    <!-- Client -->
                    <td style="vertical-align: middle;">
                        {{ anniversary.client_name }}
                    </td>

                    <!-- Date -->
                    <td style="vertical-align: middle;" class="text-center">
                        {{ anniversary.day }} / {{ anniversary.month }} / {{ anniversary.year }}
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <th>Name</th>
                    <th>Client</th>
                    <th class="text-center">Date</th>
                </tr>
            </tfoot>
        </table>
    </loading-box>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import LoadingBox from '@/components/LoadingBox'
    import Api from '@/api'

    export default {
        computed: {
           ...mapGetters({
              anniversaries: 'anniversaries/upcoming',
           })
        },

        data: () => ({
            loading: true,
        }),

        mounted() {
            if (this.anniversaries.length == 0) {
                this.fetch().then(() => {
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
        },

        methods: {
            ...mapActions({ fetch: 'anniversaries/fetch' }),
        },

        components: {
            'loading-box': LoadingBox
        }
    }
</script>
